import ListAssistances from '@/pages/Account/ListAssistances.vue';
import ListCoworkers from '@/pages/Account/ListCoworkers.vue';
import context from '@/router/guards/context';
export default [
    {
        path: 'account/assistances/list',
        name: 'account.assistances.list',
        component: ListAssistances,
        beforeEnter: [context],
    },
    {
        path: 'account/coworkers/list',
        name: 'account.coworkers.list',
        component: ListCoworkers,
        beforeEnter: [context],
    },
];
